import React from "react";
import { Helmet } from "react-helmet";

const Schema = ({ schemaData }) => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
  </Helmet>
);

export default Schema;
